import React, { Fragment } from "react";
import { Row, LogoWrapper, TooltipContentWrapper, TooltipValue, HorizontalSeparator, TooltipKey } from "../styled/Tooltip.styled";

const CapacityTooltip = ({ headerData, bodyData = [], geohash }) => {
  const { logo, isAnonymized, name } = headerData;
  return (
    <>
      <div
        style={{
          minWidth: "200px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {isAnonymized ? (
          <LogoWrapper
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30px"
            }}
          ><h4 style={{
            color: "#707070",
            fontSize: "10px",
            textAlign: "center",
            lineHeight: "18px",
            border: "1px solid #016F35",
            borderRadius: "4px",
            padding: "4px 5px",
            display: "inline-block",
            margin: "0"
          }}>
              {name}
            </h4>
          </LogoWrapper>
        )
          : !isAnonymized && logo ? (
            <Row style={{ height: "30px" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <LogoWrapper align={"center"} width={"55px"} height={"30px"}>
                  <img
                    src={logo}
                    alt="logo1"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </LogoWrapper>
              </div>
            </Row>
          ) : <></>}
        <HorizontalSeparator />
        <Fragment>
          {bodyData.map((item, idx) => {
            const { text, value } = item;
            return (
              <Row key={idx}>
                <TooltipContentWrapper>
                  <TooltipKey >
                    <div style={{ width: "140px", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {text}
                    </div>

                  </TooltipKey>
                  <TooltipValue >
                    <div style={{ width: "100px", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {value}
                    </div></TooltipValue>
                </TooltipContentWrapper>
              </Row>
            )
          })}
        </Fragment>
        <HorizontalSeparator />
        {geohash
          ? <p style={{ color: '#707070', font: 'normal normal 600 11px/19px Open Sans', textAlign: "center", margin: '0px' }}>{geohash.toUpperCase()}</p>
          : <></>}

      </div>
    </>
  );
};
export default CapacityTooltip;